export const META_TYPE = 'confidence';
export const META_VER = 'v1';

export const CMD_CONFIDENCE_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
